import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as _ from "lodash";
import {PolicyAreaSearch} from "../PA.UIM.MD/PolicyAreaSearch";
import {SalesOrgSearch} from "../PA.UIM.MD/SalesOrgSearch";
import {SnapshotTypeSearch} from "../PA.UIM.TPM/SnapshotTypeSearch";

const vUI_EventPortfolio_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_EVT_PORTFOLIO_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'WB Event Portfolio Id',
            columnResourceName: 'colId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    PORTFOLIO_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Portfolio Name', columnResourceName: 'colName', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 256}
    },
    PORTFOLIO_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Portfolio Id', columnResourceName: 'colPId', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    AUTHUSR_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Created By', columnResourceName: 'colCreatedBy', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 256}
    },
    EVENT_COUNT: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'Promotion Count',
            columnResourceName: 'colEventCount',
            alignment: HorizAlignment.Right,
            numberFormat: "#,##0"
        },
        domainOptions: {}
    },
    CREATED_DTTS: { type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Created Date', columnResourceName: 'colCreateDt', alignment: HorizAlignment.Center, dateFormat: "MM-dd-yy"}, domainOptions: {}},

    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    WB_SALESORG_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'WB Sales Org Id',
            columnResourceName: 'colwbSalesOrgId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    SALESORG_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Sales Org', columnResourceName: 'colSalesOrg', alignment: HorizAlignment.Left},
        domainOptions: {
            profileId: "default",
            bUseSearchProvidersDistinctValues: true,
            maxLength: 50
        }
    },

};

const ModelSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id: 'WB_EVT_PORTFOLIO_ID',
        id_ui: 'PORTFOLIO_ID',
        name: 'PORTFOLIO_NAME'

    },

    searchProviderFields: vUI_EventPortfolio_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
            // if (!usrContext.hasRoleId("VIEW_ALL")) {
            //     searchRequestSubset.where['WB_SALESORG_ID'] = {inq: _.map(usrContext.WB_SalesOrgs, 'WB_SALESORG_ID')}
            // }
            searchRequestSubset.where['WB_SALESORG_ID'] = {inq: _.map(usrContext.WB_SalesOrgs, 'WB_SALESORG_ID')}

            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_EventPortfolio_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                })
        })
    },
    // Filter with drop down in the Snapshot Search
    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
            let searchRequestSubset: { where?: { [id: string]: any } } = {}
            // if (!usrContext.hasRoleId("VIEW_ALL")) {
            //     searchRequestSubset = {where: {WB_SALESORG_ID: {inq: _.map(usrContext.WB_SalesOrgs, 'WB_SALESORG_ID')}}}
            // }
            searchRequestSubset = {where: {WB_SALESORG_ID: {inq: _.map(usrContext.WB_SalesOrgs, 'WB_SALESORG_ID')}}}

            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_EventPortfolio_Search',
                this.searchProviderFields,
                [fieldName])

            PASearch.findByRequest(findRequest)
                .then((results: any[]) => {
                    resolve(_.map(results, (aRow) => {
                        return aRow[fieldName]
                    }))
                })
                .catch((err) => {
                    error(err)
                })
        })
    }
};

const EventPortfolioSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5ResourceId: "EventPortfolioSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'PORTFOLIO_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'PORTFOLIO_NAME', renderOptions: {}},
        {profileFilterName: 'Created By', searchProviderFieldId: 'AUTHUSR_NAME', renderOptions: {}},
        {profileFilterName: 'Sales Org', searchProviderFieldId: 'SALESORG_NAME', bMultiSelect: true, renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'PORTFOLIO_ID', 'PORTFOLIO_NAME', 'SALESORG_NAME', 'AUTHUSR_NAME', 'EVENT_COUNT', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ModelSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const EventPortfolioSearch: ISearch = {
    searchName: "Find Event Portfolio",
    renderOptions: {ui5ResourceId: "EventPortfolioSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [EventPortfolioSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("EventPortfolioBO", "EventPortfolio", EventPortfolioSearch, "EventPortfolio Search")

export {EventPortfolioSearch}